/**
 * Hook to open real Calendly booking in a new tab reliably.
 */
export function useCalendlyPopup() {
  const openCalendlyPopup = (calendlyUrl) => {
    if (!calendlyUrl) {
      return false;
    }

    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";
    document.querySelectorAll(".calendly-overlay, .calendly-popup-content").forEach((node) => {
      node.remove();
    });

    const newWindow = window.open(calendlyUrl, "_blank", "noopener,noreferrer");
    return Boolean(newWindow);
  };

  return { openCalendlyPopup };
}

export default useCalendlyPopup;
